import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { MarsinetContext } from '../../../../../context/marsinetProvider';
import { formatUtcTimestamp } from '../../../../../utils/timezone-utils';
import { Card } from 'primereact/card';
import { RadioButton } from 'primereact/radiobutton';

function TestCard({ alarms, selectedAlarm, handleAlarmSelection }) {
  const { t, i18n } = useTranslation();
  const { selectedTimezone } = useContext(MarsinetContext);
  const testResults = [];
  let currentTest = null;

  for (const alarm of alarms) {
    if (alarm.event_type === 2) {
      if (alarm.value === 0 && !currentTest) {
        currentTest = { ...alarm };
      } else if (currentTest) {
        currentTest.value = alarm.value;
        testResults.push(currentTest);
        currentTest = null;
      }
    }
  }

  if (currentTest) {
    currentTest.value = 0;
    testResults.push(currentTest);
  }

  if (testResults.length === 0 && !selectedAlarm) return null;

  return (
    <Card className="w-full px-5 mb-5 mt-5 shadow-xl rounded-lg surface-card border-round-xl shadow-3">
      {testResults.map((alarm) => (
        <div
          key={alarm.timestamp}
          className="flex items-center justify-between p-3 border border-gray-500 rounded-lg shadow-sm"
        >
          <div className="flex items-center gap-2 w-full">
            <RadioButton
              name="selectedAlarm"
              value={alarm}
              onClick={() => handleAlarmSelection(alarm)}
              checked={
                selectedAlarm &&
                selectedAlarm.event_id === alarm.event_id &&
                selectedAlarm.timestamp === alarm.timestamp
              }
              className="mr-2"
            />
            <div className="flex items-center justify-between w-full">
              <span className="flex gap-4">
                <span>
                  <strong>{t('pages.alarms.eventId')}:</strong> {alarm.event_id}
                </span>
                <span>
                  <strong>{t('pages.alarms.status')}:</strong>{' '}
                  <span
                    className={`${
                      alarm.value === 1 ? 'text-green-600' : 'text-red-600'
                    } font-medium`}
                  >
                    {alarm.value === 1
                      ? t('pages.maintenance.test.ok')
                      : t('pages.maintenance.test.fail')}
                  </span>
                </span>
              </span>
            </div>
          </div>
        </div>
      ))}

      {/* Mostrar la alarma seleccionada, si existe */}
      {selectedAlarm && (
        <div className="p-4 bg-gray-50 rounded-lg mt-4 shadow-md border border-gray-300">
          <p className="mb-2">
            <span className="font-semibold">{t('pages.alarms.date')}:</span>{' '}
            {formatUtcTimestamp(
              selectedAlarm.date,
              selectedTimezone,
              i18n.language
            )}
          </p>
          <p className="mb-2">
            <span className="font-semibold">{t('pages.alarms.eventId')}:</span>{' '}
            {selectedAlarm.event_id}
          </p>
          <p className="mb-2">
            <span className="font-semibold">{t('pages.alarms.message')}:</span>{' '}
            {t(`pages.alarms.alarms.${selectedAlarm.event_id}`)}
          </p>
          <p className="mb-2">
            <span className="font-semibold">{t('pages.alarms.params')}:</span>{' '}
            {selectedAlarm.params && selectedAlarm.params.length > 0
              ? selectedAlarm.params.map((param, index) => (
                  <span key={param.id}>
                    {param}
                    {index < selectedAlarm.params.length - 1 && ', '}
                  </span>
                ))
              : t('pages.alarms.noParams')}
          </p>
          <p className="mb-2">
            <span className="font-semibold">{t('pages.alarms.status')}:</span>{' '}
            <span
              className={`${
                selectedAlarm.value === 1 ? 'text-green-600' : 'text-red-600'
              } font-medium`}
            >
              {selectedAlarm.value === 1
                ? t('pages.maintenance.test.ok')
                : t('pages.maintenance.test.fail')}
            </span>
          </p>
        </div>
      )}
    </Card>
  );
}

export default TestCard;
